import React from "react";
import {
  convertThenFormat,
  formatDateTimezon,
} from "../../../common-data/Converts";
import moment from "moment";
import { ProfileIcon, PTIcon } from "../../../../images/icons/icons";

const AllPlans = ({ allPlanData }) => {
  function getSubsProgress(start_date, expire_date) {
    const startDate = moment(start_date).tz("Asia/Kolkata");
    const expireDate = moment(expire_date).tz("Asia/Kolkata");
    const currentDate = moment().tz("Asia/Kolkata");

    if (startDate.isAfter(currentDate) || expireDate.isBefore(currentDate)) {
      const totalDuration = expireDate.diff(startDate, "days");
      const res = {
        daysLeft: startDate.isAfter(currentDate) ? totalDuration : 0,
        percentageConsumed: 0,
      };
      return res;
    }

    const totalDuration = expireDate - startDate;
    const consumedDuration = currentDate - startDate;
    const percentageConsumed = (consumedDuration / totalDuration) * 100;
    const daysLeft = expireDate.diff(currentDate, "days");
    const res = {
      daysLeft,
      percentageConsumed: percentageConsumed || 100,
    };
    return res;
  }

  return (
    <>
      {allPlanData?.map((item, index) => {
        const {
          type,
          plan_name,
          addon_name,
          subscription_status,
          trainer_name,
          sub_added_by_name,
          sub_added_by_mobile,
          sub_added_by_email,
          price,
          start_date,
          expire_date,
          completed_session,
          n_session,
        } = item || {};

        const planName =
          type === "regular"
            ? plan_name
            : type === "addon_pt"
            ? addon_name
            : type;

        const planStatusBg =
          subscription_status === "active" ? "#09BA09" : "#BA0934";

        const startDate = start_date ? formatDateTimezon(start_date) : "-";
        const endDate = expire_date ? formatDateTimezon(expire_date) : "-";

        // const daysLeft = getSubsProgress(start_date, expire_date).daysLeft;
        const subsProgress = getSubsProgress(start_date, expire_date);
        const daysLeft = subsProgress.daysLeft;
        const percentageConsumed = subsProgress.percentageConsumed;

        return (
          <div className="membership-plans" key={index}>
            <div className="plan-col icon">
              <div className="icon-box">
                {type === "addon_pt" ? <PTIcon /> : <ProfileIcon />}
              </div>
            </div>
            <div className="plan-col details">
              <div className="plan-name-and-status flexBetween">
                <h3 className="plan-name">{planName || "NA"}</h3>
                <span
                  className="plan-status"
                  style={{
                    background: planStatusBg,
                  }}
                >
                  {subscription_status || "NA"}
                </span>
              </div>
              <div className="info-label-and-value">
                <span className="label">trainer name:</span>
                <span className="value">{trainer_name || "NA"}</span>
              </div>
              <div className="info-label-and-value">
                <span className="label">Amount Paid:</span>
                <span className="value">₹{convertThenFormat(price || 0)}</span>
              </div>
              <div className="info-label-and-value">
                <span className="label">Plan Duration:</span>
                <span className="value">
                  {startDate} - {endDate}
                </span>
              </div>
              {type === "addon_pt" && (
                <div className="info-label-and-value">
                  <span className="label">Session Status:</span>
                  <span className="value">
                    {completed_session || 0} / {n_session || 0}
                  </span>
                </div>
              )}

              <div className="info-label-and-value flex-col">
                <span className="label">Plan Progress:</span>
                <div className="plan-progress-wrapper">
                  <span className="days-left-badge">
                    {daysLeft || 0} days left
                  </span>
                  <div className="progress-bar plan-progress-bar">
                    <div
                      className="progress-fill plan-progress-fill"
                      role="progressbar"
                      aria-valuenow={Math.min(percentageConsumed || 0, 100)}
                      aria-valuemin="0"
                      aria-valuemax="100"
                      aria-label={`${daysLeft || 0} days remaining`}
                      style={{
                        height: "100%",
                        backgroundColor: "#10B981",
                        width: `${Math.min(percentageConsumed || 0, 100)}%`,
                        transition: "width 0.3s ease",
                        borderRadius: "4px",
                      }}
                    />
                  </div>
                </div>
                {/* <span className="label">Days Left:</span>
                <span
                  className="value"
                  style={{
                    padding: "2px 5px",
                    background: "#0A4CCC",
                    color: "#fff",
                    borderRadius: "5px",
                  }}
                >
                  {daysLeft || 0}
                </span> */}
              </div>

              <div
                className={`info-label-and-value ${
                  sub_added_by_name ? "flex-col" : ""
                }`}
              >
                <span className="label">subscription added by:</span>
                <span className="value">
                  {sub_added_by_name || "NA"}
                  <br />
                  {(sub_added_by_mobile || sub_added_by_email) && (
                    <span className="lowercase underline">
                      {sub_added_by_mobile || ""}
                      <br />
                      {sub_added_by_email || ""}
                    </span>
                  )}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default AllPlans;
